import { gql } from '@apollo/client';

export const GET_FLYER_DISTRIBUTION_INFO = gql`
  query getFlyerDistributionInfo($input: FlyerDistributionInfoInput!) {
    getFlyerDistributionInfo(input: $input) {
      newDistribution {
        unreadFlyers
        lastUpdate
      }
      upcomingDistribution {
        expiringThisWeek
        lastUpdate
      }
    }
  }
`;
